var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C18.9101 0 18.8192 0.0237699 18.7402 0.0722699L2.24023 10.0723C2.00423 10.2153 1.92926 10.5238 2.07226 10.7598C2.16601 10.9151 2.33118 10.9902 2.49999 10.9902V11H35.5C35.669 11 35.8337 10.9138 35.9277 10.7598C36.0707 10.5238 35.9958 10.2153 35.7598 10.0723L19.2598 0.0722799C19.1803 0.0237799 19.0899 0 19 0ZM19 1.08398L33.709 10H4.29101L19 1.08398ZM5.5 12V29H2.5C2.224 29 2 29.224 2 29.5C2 29.776 2.224 30 2.5 30H35.5C35.776 30 36 29.776 36 29.5C36 29.224 35.776 29 35.5 29H32.5V12H30.5V29H26.25V12H24.25V29H20V12H18V29H13.75V12H11.75V29H7.5V12H5.5ZM0.5 34C0.224 34 0 34.224 0 34.5C0 34.776 0.224 35 0.5 35H37.5C37.776 35 38 34.776 38 34.5C38 34.224 37.776 34 37.5 34H0.5Z",
    fill: "#E87975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniIcon);
export default __webpack_public_path__ + "static/media/Uni_Icon.fca0f89f4a8904a237dbd5e400d83467.svg";
export { ForwardRef as ReactComponent };